import React, { useEffect, useCallback } from 'react';
import PropTypes from "prop-types";
import { Link } from "react-router";
import { Collapse } from 'reactstrap';
import Navdata from "./LayoutMenuData";
import withRouter from ".././components/withRouter";
import { useSelector } from "react-redux";
import { createSelector } from 'reselect';

const VerticalLayout = (props : any) => {
    const navData = Navdata().props.children;
    const path = props.router.location.pathname;

    /*
 layout settings
 */

    const selectLayoutState = (state : any) => state.Layout;
    const selectLayoutProperties = createSelector(
        selectLayoutState,
        (layout) => ({
            leftsidbarSizeType: layout.leftsidbarSizeType,
            sidebarVisibilitytype: layout.sidebarVisibilitytype,
            layoutType: layout.layoutType
        })
    );
    // Inside your component
    const {
        leftsidbarSizeType, sidebarVisibilitytype
    } = useSelector(selectLayoutProperties);

    //vertical and semibox resize events
    const resizeSidebarMenu = useCallback(() => {
        var windowSize = document.documentElement.clientWidth;
        const hamburgerIcon = document.querySelector(".hamburger-icon") as HTMLElement;
        if (windowSize >= 1025) {
            document.documentElement.setAttribute("data-sidebar-size", leftsidbarSizeType);
            if (sidebarVisibilitytype === "show" && document.querySelector(".hamburger-icon")) {
                if (hamburgerIcon !== null) {
                    hamburgerIcon.classList.remove("open");
                }
            } else {
                // var hamburgerIcon = document.querySelector(".hamburger-icon");
                if (hamburgerIcon !== null) {
                    hamburgerIcon.classList.add("open");
                }
            }

        } else if (windowSize < 1025 && windowSize > 767) {
            document.documentElement.setAttribute("data-sidebar-size", "sm");
            if (hamburgerIcon) {
                hamburgerIcon.classList.add("open");
            }
        } else if (windowSize <= 767) {
            document.body.classList.remove("vertical-sidebar-enable");
            document.documentElement.setAttribute("data-sidebar-size", "lg");
            if (hamburgerIcon) {
                hamburgerIcon.classList.add("open");
            }
        }
    }, [leftsidbarSizeType, sidebarVisibilitytype]);

    useEffect(() => {
        window.addEventListener("resize", resizeSidebarMenu, true);
    }, [resizeSidebarMenu]);

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        const initMenu = () => {
            const pathName = process.env.PUBLIC_URL + path;
            const currentPath = pathName.replace(process.env.PUBLIC_URL || '', '');
            const ul = document.getElementById("navbar-nav") as HTMLElement;
            const items : any = ul.getElementsByTagName("a");
            let itemsArray = [...items]; // converts NodeList to Array
            removeActivation(itemsArray);
            let matchingMenuItem = itemsArray.find((x) => {
                const menuPath = x.pathname.replace(process.env.PUBLIC_URL || '', '');
                
                // Skip placeholder links
                if (menuPath === '/#' || menuPath === '/public#' || menuPath === '') {
                    return false;
                }
                
                // Exact match first
                if (currentPath === menuPath) {
                    return true;
                }
                
                // Then check if current path starts with menu path (for nested routes)
                // But ensure it's not just a partial match (e.g., /tag shouldn't match /tags)
                return currentPath.startsWith(menuPath + '/') || 
                       (currentPath.startsWith(menuPath) && currentPath.length > menuPath.length && currentPath[menuPath.length] === '/');
            });
            if (matchingMenuItem) {
                activateParentDropdown(matchingMenuItem);
            }
        };
        initMenu();
    }, [path, props.layoutType]);

    function activateParentDropdown(item: any) {
        // Add active class to the clicked item
        item.classList.add("active");
        
        // Find parent dropdown and activate it
        let parentCollapseDiv = item.closest(".collapse.menu-dropdown");

        if (parentCollapseDiv) {
            // Show the dropdown
            parentCollapseDiv.classList.add("show");
            
            // Activate the parent menu link
            const parentMenuLink = parentCollapseDiv.parentElement.children[0];
            if (parentMenuLink) {
                parentMenuLink.classList.add("active");
                parentMenuLink.setAttribute("aria-expanded", "true");
            }
            
            // Handle nested dropdowns
            if (parentCollapseDiv.parentElement.closest(".collapse.menu-dropdown")) {
                const grandParentCollapse = parentCollapseDiv.parentElement.closest(".collapse");
                if (grandParentCollapse) {
                    grandParentCollapse.classList.add("show");
                    const grandParentLink = grandParentCollapse.previousElementSibling;
                    if (grandParentLink) {
                        grandParentLink.classList.add("active");
                    }
                }
            }
            return true;
        }
        return false;
    }

    const removeActivation = (items :any) => {
        let actiItems = items.filter((x : any) => x.classList.contains("active"));

        actiItems.forEach((item : any) => {
            if (item.classList.contains("menu-link")) {
                if (!item.classList.contains("active")) {
                    item.setAttribute("aria-expanded", false);
                }
                if (item.nextElementSibling) {
                    item.nextElementSibling.classList.remove("show");
                }
            }
            if (item.classList.contains("nav-link")) {
                if (item.nextElementSibling) {
                    item.nextElementSibling.classList.remove("show");
                }
                item.setAttribute("aria-expanded", false);
            }
            item.classList.remove("active");
        });
    };

    return (
        <React.Fragment>
            {/* menu Items */}
            {(navData || []).map((item : any, key : number) => {
                return (
                    <React.Fragment key={key}>
                        {/* Main Header */}
                        {item['isHeader'] ?
                            <li className="menu-title"><span data-key="t-menu">{item.label} </span></li>
                            : (
                                (item.subItems ? (
                                    <li className="nav-item">
                                        <Link
                                            onClick={item.click}
                                            className="nav-link menu-link"
                                            to={item.link ? item.link : "/public#"}
                                            data-bs-toggle="collapse"
                                        >
                                            <i className={item.icon}></i>
                                            <span data-key="t-apps">{item.label}</span>
                                            {item.badgeName ?
                                                <span className={"badge badge-pill bg-" + item.badgeColor} data-key="t-new">{item.badgeName}</span>
                                                : null}
                                        </Link>
                                        <Collapse
                                            className="menu-dropdown"
                                            isOpen={item.stateVariables}
                                            id="sidebarApps">
                                            <ul className="nav nav-sm flex-column test">
                                                {/* subItms  */}
                                                {item.subItems && ((item.subItems || []).map((subItem : any, key : number) => (
                                                    <React.Fragment key={key}>
                                                        {!subItem.isChildItem ? (
                                                            <li className="nav-item">
                                                                <Link
                                                                    to={subItem.link ? subItem.link : "/public#"}
                                                                    className="nav-link"
                                                                >
                                                                    {subItem.label}
                                                                    {subItem.badgeName ?
                                                                        <span className={"badge badge-pill bg-" + subItem.badgeColor} data-key="t-new">{subItem.badgeName}</span>
                                                                        : null}
                                                                </Link>
                                                            </li>
                                                        ) : (
                                                            <li className="nav-item">
                                                                <Link
                                                                    onClick={subItem.click}
                                                                    className="nav-link"
                                                                    to="/public#"
                                                                    data-bs-toggle="collapse"
                                                                >
                                                                    {subItem.label}
                                                                    {subItem.badgeName ?
                                                                        <span className={"badge badge-pill bg-" + subItem.badgeColor} data-key="t-new">{subItem.badgeName}</span>
                                                                        : null}
                                                                </Link>
                                                                <Collapse className="menu-dropdown" isOpen={subItem.stateVariables} id="sidebarEcommerce">
                                                                    <ul className="nav nav-sm flex-column">
                                                                        {/* child subItms  */}
                                                                        {subItem.childItems && (
                                                                            (subItem.childItems || []).map((childItem : any, key : number) => (
                                                                                <React.Fragment key={key}>
                                                                                    {!childItem.childItems ?
                                                                                        <li className="nav-item">
                                                                                            <Link
                                                                                                to={childItem.link ? childItem.link : "/public#"}
                                                                                                className="nav-link">
                                                                                                {childItem.label}
                                                                                            </Link>
                                                                                        </li>
                                                                                        : <li className="nav-item">
                                                                                            <Link to="/public#" className="nav-link" onClick={childItem.click} data-bs-toggle="collapse">
                                                                                                {childItem.label}
                                                                                            </Link>
                                                                                            <Collapse className="menu-dropdown" isOpen={childItem.stateVariables} id="sidebaremailTemplates">
                                                                                                <ul className="nav nav-sm flex-column">
                                                                                                    {childItem.childItems.map((subChildItem : any, key : number) => (
                                                                                                        <li className="nav-item" key={key}>
                                                                                                            <Link to={subChildItem.link} className="nav-link" data-key="t-basic-action">{subChildItem.label} </Link>
                                                                                                        </li>
                                                                                                    ))}
                                                                                                </ul>
                                                                                            </Collapse>
                                                                                        </li>
                                                                                    }
                                                                                </React.Fragment>
                                                                            ))
                                                                        )}
                                                                    </ul>
                                                                </Collapse>
                                                            </li>
                                                        )}
                                                    </React.Fragment>
                                                ))
                                                )}
                                            </ul>

                                        </Collapse>
                                    </li>
                                ) : (
                                    <li className="nav-item">
                                        <Link
                                            className="nav-link menu-link"
                                            target={item.target ? item.target : "_self"}
                                            to={item.link ? item.link : "/public#"}>
                                            <i className={item.icon}></i> <span>{item.label}</span>
                                            {item.badgeName ?
                                                <span className={"badge badge-pill bg-" + item.badgeColor} data-key="t-new">{item.badgeName}</span>
                                                : null}
                                        </Link>
                                    </li>
                                ))
                            )
                        }
                    </React.Fragment>
                );
            })}
        </React.Fragment>
    );
};

VerticalLayout.propTypes = {
    location: PropTypes.object,
    t: PropTypes.any,
};

export default withRouter(VerticalLayout);